<template>
  <div class="vipProductList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        @click="vipOperation('add',tableData)"
        class="add-input"
      >+新增</el-button>
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="id"
        label="id"
        align="center"
        fixed
        width="200"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="名称" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.name }}</span>
        </template>
      </el-table-column>
        <el-table-column prop="showType" label="展示样式" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.showType |showTypeList }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="开关" align="center" width="160">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" width="160" sortable></el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="vipOperation('edit',scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeAdmin(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <position-action ref="positionAction" @handlerProductList="handlerProductList"></position-action>
  </div>
</template>
<script>
import API from "@/api";
import positionAction from "./components/positionAction";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,

      tableData: [],
      // 列表请求参数
      param: {
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  components: {
    positionAction,
  },
  created() {
    this.getPositionList(this.param);
  },
  methods: {
    // 请求商品列表
    getPositionList() {
      this.loading = true;
      API.getPositionList(this.param)
        .then((res) => {
          if (res.code === 200 && res.data.list.length > 0) {
            this.tableData = res.data.list;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 删除管理员
    removeAdmin(row) {
      this.$confirm("您确定要删除当前项吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deletePosition({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getPositionList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    vipOperation(type, data) {
      this.$refs.positionAction.open(type, data);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getPayGoldList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getPayGoldList();
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerProductList() {
      this.getPositionList();
    },
  },
};
</script>

<style lang="scss">
.add-input {
  margin-left: 0 !important;
}
</style>
